import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import NewslettersPageForm from './newsletters_page_form';

class NewsletterPage extends Component {
  render() {
    const availableNewsletters = Object.keys(
      get(this.props, 'config.newsletters') || {}
    ).map(function mapNewsletterData(newsletterPropName) {
      const isDefault = newsletterPropName === 'fastcompany';
      return {
        default: isDefault,
        list: newsletterPropName
      };
    });
    if (this.props.staticPage.error) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.staticPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    return (
      <section className="custom-content">
        <div className="nl-page">
          <div className="nl-page__header">
            <h2 className="nl-page__title">Never miss a story.</h2>
            <p className="nl-page__dek">
              Get the latest stories and updates sent your inbox.
            </p>
          </div>
          <NewslettersPageForm
            newsletters={availableNewsletters}
            config={this.props.config}
          />
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    staticPage: state.staticPage || {},
    config: state.config
  };
}

NewsletterPage.propTypes = {
  config: PropTypes.shape({
    newsletters: PropTypes.shape({}).isRequired
  }).isRequired,
  staticPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired
};

export default connect(mapStateToProps)(NewsletterPage);



// WEBPACK FOOTER //
// ./src/views/containers/pages/newsletters_page/newsletters_page.js